import { memo, useEffect, useState } from "react";
import { useMiningStore } from "../../../../Store/miningStore";
import { MiningService } from "../../services/MiningService";
import { useMiningStatus } from "../../hooks/useMiningStatus";
import MiningInfo from "../MiningInfo/MiningInfo";
import styles from "./MiningCard.module.css";
import { BoostMiningService } from "../../services/BoostMiningService";
import { useBoostTaskStore } from "../../../../Store/BoostTaskStore";
import { useModalStore } from "../../../../Store/ModalStore";
import { boostMining } from "../../../../Services/Requests";
import { useNotificationStore } from "../../../../Store/NotificationStore";
import { useDoubleClickStore } from "../../../../Store/DoubleClickStore";
import { RichAdsBoostProvider } from "../../services/boost/RichAdsBoostProvider";
import { BoostTask } from "../../types/boost";

const MiningCard = memo(() => {
  const miningData = useMiningStore((state) => state.miningData);
  const setMiningData = useMiningStore((state) => state.setMiningData);
  const { rewards } = useMiningStatus();
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const doubleClick = useDoubleClickStore((state) => state.doubleClick);
  const setDoubleClick = useDoubleClickStore((state) => state.setDoubleClick);

  useEffect(() => {
    const handleRichAdsClose = () => {
      console.log("richads-close-clicked: Пользователь закрыл рекламу");

      // Здесь можно вызвать setDoubleClick(false), если это необходимо
      setDoubleClick(false);
    };

    window.addEventListener("richads-close-clicked", handleRichAdsClose);

    return () => {
      window.removeEventListener("richads-close-clicked", handleRichAdsClose);
    };
  }, []);

  const progressWidth = 20 + rewards.percentageComplete * 0.8;

  // Определяем класс в зависимости от статуса
  const progressBarClassName = `${styles.progressBar} ${
    miningData?.mining.status === "claim"
      ? styles.progressBarClaim
      : styles.progressBarProcess
  }`;
  // console.log(rewards.percentageComplete);
  const handleClick = async () => {
    if (!miningData) return;
    if (doubleClick) return;
    try {
      let response;

      if (MiningService.canStart(miningData.mining.status)) {
        response = await MiningService.startMining();
      } else if (MiningService.canClaim(miningData.mining.status)) {
        setDoubleClick(true);
        try {
          let currentMiningId = miningData.mining.id;
          const availableTasks = await Promise.race([
            BoostMiningService.getAllAvailableTasksNoAdexium(currentMiningId),
            new Promise<BoostTask[]>((_, reject) =>
              setTimeout(
                () => reject(new Error("Таймаут получения заданий (10 сек)")),
                10000
              )
            ),
          ]);

          let isBoostSuccessful = false;

          if (availableTasks.length > 0) {
            for (const task of availableTasks) {
              const showGenericModal =
                task.provider === "Barza" ||
                task.provider === "TappAds" ||
                task.provider === "DreamCoin" ||
                task.provider === "Barzha";

              if (showGenericModal) {
                console.log("Открываем модальное окно для рекламы");
                useBoostTaskStore.getState().setCurrentTask(task);
                useModalStore.getState().setOpen("boost", "miningCard");

                break;
              } else {
                console.log("Прямой показ рекламы");
                const result = await task.onClick();
                console.log("Результат показа рекламы:", result);

                if (result === "success") {
                  console.log("Реклама успешно просмотрена");
                  isBoostSuccessful = true;
                  try {
                    await boostMining(
                      miningData.mining.id,
                      task.provider.toLowerCase(),
                      setNotification,
                      "claim"
                    );
                  } catch (error) {
                    console.error("Ошибка!", error);
                  }
                  setDoubleClick(false);
                  console.log("Реклама успешно показана напрямую");
                  break;
                } else if (result === "user_cancelled") {
                  console.log("Пользователь отменил просмотр рекламы");
                  isBoostSuccessful = false;
                  setDoubleClick(false);
                  break;
                } else if (
                  result === "ads_not_found" &&
                  availableTasks.length === 1
                ) {
                  isBoostSuccessful = true;
                  console.log(
                    "No available tasks!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"
                  );
                  setDoubleClick(false);
                  break;
                }
              }
            }
          } else {
            isBoostSuccessful = true;
            console.log(
              "No available tasks!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"
            );
            setDoubleClick(false);
          }

          console.log("Текущее значение isBoostSuccessful:", isBoostSuccessful);

          if (isBoostSuccessful) {
            response = await MiningService.claimMining(miningData.mining.id);
            setDoubleClick(false);
          } else {
            console.log(
              "claimMining не вызван, так как isBoostSuccessful = false"
            );
            setDoubleClick(false);
          }
        } catch (error) {
          console.error("Ошибка при показе рекламы:", error);
          // Если произошел таймаут, считаем операцию успешной
          if (error instanceof Error && error.message.includes("Таймаут")) {
            console.log("Произошел таймаут, считаем операцию успешной");
            const response = await MiningService.claimMining(
              miningData.mining.id
            );
            if (response) {
              setMiningData(response);
            }
          }
          setDoubleClick(false);
        }
      }

      if (response) {
        setMiningData(response);
      }
    } catch (error) {
      console.error("Ошибка при выполнении действия с майнингом:", error);
    }
  };

  const isClickable =
    miningData &&
    !doubleClick &&
    (MiningService.canClaim(miningData.mining.status) ||
      MiningService.canStart(miningData.mining.status));

  return (
    <div
      className={`${styles.miningCard} ${doubleClick ? styles.claimReady : ""}`}
    >
      <div className={styles.progressBarContainer}>
        <div
          className={progressBarClassName}
          style={{
            width: `${progressWidth}%`,
            transition: "width 0.3s ease-out",
          }}
        />
      </div>
      <div
        className={styles.content}
        onClick={handleClick}
        style={{
          cursor: isClickable ? "pointer" : "default",
          opacity: doubleClick ? 0.7 : 1,
          pointerEvents: doubleClick ? "none" : "auto",
        }}
      >
        <MiningInfo />
      </div>
    </div>
  );
});

MiningCard.displayName = "MiningCard";

export default MiningCard;
